import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './UnderConstruction.scss';

const UnderConstruction: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <div className="under-construction">
      <div className="under-construction__content">
        <h2 className="under-construction__title">Under Construction</h2>
        <p className="under-construction__message">
          Check back later for updates!
        </p>
        {!isAuthenticated && (
          <button 
            className="under-construction__login-btn"
            onClick={handleLoginClick}
          >
            Login for Development Access
          </button>
        )}
      </div>
    </div>
  );
};

export default UnderConstruction;